export const testTypes = {
  EXTRAMURAL: 1,
  FULL_TIME: 5,
}
